import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { map, tap, catchError, shareReplay } from 'rxjs/operators';
import { WindowRefService } from '../../../../services/window-ref.service';
import { SessionStorageService } from '../../../../services/web-storage/session-storage.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../services/window-ref.service";
import * as i3 from "../../../../services/web-storage/session-storage.service";
var ContentVersioningService = /** @class */ (function () {
    function ContentVersioningService(http, windowRefService, sessionStorageService) {
        this.http = http;
        this.windowRefService = windowRefService;
        this.sessionStorageService = sessionStorageService;
        this.dataStoreKey = 'maContentVersion';
    }
    ContentVersioningService.prototype.getVersion = function (contentId) {
        var _this = this;
        return this.getVersions().pipe(map(function (source) {
            return _this.findContentVersion(contentId, source);
        }));
    };
    ContentVersioningService.prototype.getVersions = function () {
        var _this = this;
        var storageValue = this.sessionStorageService.getItem(this.dataStoreKey, true);
        if (storageValue) {
            return of(storageValue);
        }
        if (this.contentVersionObservable) {
            return this.contentVersionObservable;
        }
        var url = this.getFullApiUrl();
        this.contentVersionObservable = this.http.get(url).pipe(map(function (resp) {
            return resp && resp.resources;
        }), tap(function (versionInfos) {
            _this.sessionStorageService.setItem(_this.dataStoreKey, versionInfos, true);
        }), catchError(function (error) {
            return of({});
        }), shareReplay(1));
        return this.contentVersionObservable;
    };
    ContentVersioningService.prototype.getFullApiUrl = function () {
        return this.windowRefService.nativeWindow.environment.CONTENT_CDN_URL +
            '/mypru/v1/config/api-list.json';
    };
    ContentVersioningService.prototype.findContentVersion = function (contentId, source) {
        var defaultVersion = '0';
        if (!source) {
            return defaultVersion;
        }
        var foundMatches = Object.keys(source).filter(function (item) {
            return item && item.indexOf(contentId) > 0;
        });
        if (foundMatches && foundMatches.length > 0) {
            return source[foundMatches[0]].v;
        }
        return defaultVersion;
    };
    ContentVersioningService.ngInjectableDef = i0.defineInjectable({ factory: function ContentVersioningService_Factory() { return new ContentVersioningService(i0.inject(i1.HttpClient), i0.inject(i2.WindowRefService), i0.inject(i3.SessionStorageService)); }, token: ContentVersioningService, providedIn: "root" });
    return ContentVersioningService;
}());
export { ContentVersioningService };
